import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { defaultButtonStyle, primaryButtonStyle, largeButtonStyle } from '../base';
import media from '../base/media';

export const Wrapper = styled.div`
	max-width: 1920px;
	margin: 0 auto;
`;

export const Content = styled.div`
	padding: 2rem 0;

	${media.tablet`
		padding: 10rem 0;
	`}

	${media.tabletOnly`
		padding-bottom: 0;
	`}
`;

export const TitleRow = styled.div`
	display: block;
	margin-bottom: 3rem;

	${media.tablet`
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 5rem;
	`}
`;

export const TitleStreetWrapper = styled.div`
	display: flex;
	flex-direction: column-reverse;

	${media.tablet`
		display: block;
	`}
`;

export const PriceWrapper = styled.div`
	display: flex;
	font-size: 2rem;
	margin-top: 2rem;

	${media.tablet`
		margin-top: 0;
	`}
`;

export const Price = styled.div`
	font-weight: 700;
	color: ${({ theme }) => theme.colors.primary};
	margin-right: 0.5rem;
`;

export const PricePr = styled.div`
	font-weight: 700;
	color: ${({ theme }) => theme.colors.black};
	margin-left: 0.5rem;
`;

export const MainText = styled.div`

`;

export const InfoBox = styled.div`
	${media.tablet`
		margin-top: 7rem;
		padding: 3rem;
		background-color: #fff;
		box-shadow: 0 7px 27px 0 rgba(147,94,196,0.1);
	`}

	${media.desktopSmall`
		padding: 4rem 6rem 6rem 6rem;
	`}
`;

export const InfoBoxLine = styled.div`
	display: flex;
	align-items: center;
	margin-bottom: 2rem;
	font-weight: 700;
	font-size: 1.4rem;
	color: ${({ theme }) => theme.colors.black};

	svg {
		flex: 2.4rem 0 0;
		margin-right: 4rem;
	}
`;

export const ApplyForApartmentButton = styled(Link)`
	${defaultButtonStyle};
	${primaryButtonStyle};
	${largeButtonStyle};
	width: 100%;
	margin-top: 4rem;
`;

export const ButtonInfoText = styled.div`
	margin-top: 3rem;
	font-size: 1.4rem;
	line-height: 1.8;
`;

export const ButtonInfoTextStrong = styled.span`
	font-weight: 600;
	color: ${({ theme }) => theme.colors.black};
`;
